"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTypeToType = exports.convertStringsToPublicKeys = exports.convertNumbersToBNs = void 0;
const anchor_1 = require("@project-serum/anchor");
function convertNumbersToBNs(data, keysToUpdate = []) {
    return convertTypeToType(data, keysToUpdate, "number", (value) => new anchor_1.BN(value));
}
exports.convertNumbersToBNs = convertNumbersToBNs;
function convertStringsToPublicKeys(data, keysToUpdate = []) {
    return convertTypeToType(data, keysToUpdate, "string", (value) => new anchor_1.web3.PublicKey(value));
}
exports.convertStringsToPublicKeys = convertStringsToPublicKeys;
const isRecord = (b) => {
    return typeof b === "object" && b !== null;
};
const isType = (item, typeInQuestion) => {
    return (typeof typeInQuestion === "string" ? typeof item == typeInQuestion :
        (typeof item === "object" && !Array.isArray(item) && item instanceof typeInQuestion));
};
/**
 * Runs `toType` over variables matching the patterns in keys from `existingType`
 * in order to convert them to the desired type
 * You may need to use with an `as` to satisfy Typescript:
 *    convertTypeToType(y, ["a"], "string", Number) as YourNewType
 */
function convertTypeToType(data, keysToUpdate, existingType, toType) {
    if (Array.isArray(data)) {
        return data.map((item) => {
            if (isType(item, existingType)) {
                return toType(item);
            }
            if (keysToUpdate && keysToUpdate.length > 0) {
                const parsedKeys = keysToUpdate[0].split(".");
                const [firstKey, ...remainingKeys] = parsedKeys;
                if (firstKey === "[]" && (remainingKeys === null || remainingKeys === void 0 ? void 0 : remainingKeys.length) > 0) {
                    return convertTypeToType(item, [remainingKeys.join(".")], existingType, toType);
                }
            }
            return item;
        });
    }
    if (keysToUpdate && isRecord(data)) {
        keysToUpdate.forEach((key) => {
            const parsedKeys = key.split(".");
            const [firstKey, ...remainingKeys] = parsedKeys;
            if (firstKey in data) {
                if (parsedKeys.length === 1) {
                    if (Array.isArray(data[firstKey])) {
                        data[firstKey] = convertTypeToType(data[firstKey], [], existingType, toType);
                    }
                    if (isType(data[firstKey], existingType)) {
                        data[firstKey] = toType(data[firstKey]);
                    }
                }
                else {
                    data[firstKey] = convertTypeToType(data[firstKey], [remainingKeys.join(".")], existingType, toType);
                }
            }
        });
    }
    return data;
}
exports.convertTypeToType = convertTypeToType;
//# sourceMappingURL=utils.js.map